import { getUsers } from '../services/iam';

/**
 * The user list behind a "filter by user" select (design eval F9).
 *
 * getUsers() with no limit returned only the backend's default page, so the
 * select silently left people out. One shared query asks for a large page and
 * reports how many exist, so the filter can say when it is incomplete.
 */
export const USER_FILTER_LIMIT = 500;

export const userFilterQuery = ['users', 'filter', USER_FILTER_LIMIT] as const;

export const fetchUserFilterOptions = () => getUsers({ limit: USER_FILTER_LIMIT, offset: 0 });

/** Help text for the select, or undefined when every user is listed. */
export function userFilterHelp(data: { data?: unknown[]; total?: number } | undefined): string | undefined {
  const shown = data?.data?.length ?? 0;
  const total = data?.total ?? 0;
  return total > shown ? `Showing ${shown} of ${total} users. Filter by resource or result to narrow further.` : undefined;
}
